import { collection, addDoc } from "firebase/firestore"; // Client SDK

export const createDeliveryMailConfirmation = async (
  db,
  orderData,
  mail_type,
) => {
  const {
    buyerEmail,
    shippingCost,
    items,
    sooperstock_order_id,
    shipmentAddress,
    tracking_number,
    tracking_carrier,
  } = orderData;

  // Build HTML for order items with updated design
  let itemsHtml = "";
  let totalPrice = 0;
  items.forEach((item) => {
    const pricePerUnit = item.final_price || 0;
    const linePrice = (pricePerUnit * item.quantity).toFixed(2);
    totalPrice += pricePerUnit * item.quantity;

    const imageUrl =
      item?.images && item.images.length > 0
        ? item.images[0]
        : "https://firebasestorage.googleapis.com/v0/b/fullproof-app.firebasestorage.app/o/Logos%2Fno_product_image.png?alt=media&token=54805bf7-c43a-4a75-b0ae-0f5e9330c724";

    itemsHtml += `
      <tr style="border-bottom:1px solid #ddd;">
        <td style="padding:10px; width:60px; height:60px; text-align:center; background-color:#f5f5f5;">
          <img src="${imageUrl}" alt="${item.product_name}" width="50" height="50" style="object-fit:cover;" />
        </td>
        <td style="padding:10px; text-align:left;">
          <p style="margin:0; font-size:14px;">${item.product_name}</p>
          <p style="margin:0; font-size:14px;">Qty: ${item.quantity}</p>
          <p style="margin:0; font-size:14px;">$${linePrice}</p>
        </td>
        <td style="padding:10px; text-align:right;"></td>
      </tr>
    `;
  });

  // Calculate totals – add shipping cost if provided
  const shippingDollars = shippingCost
    ? (shippingCost / 100).toFixed(2)
    : "0.00";
  const totalDollars = (totalPrice + parseFloat(shippingDollars)).toFixed(2);
  itemsHtml += `
    <tr>
      <td colspan="2" style="padding:10px; text-align:left; font-size:18px; font-weight:bold;">Total*</td>
      <td style="padding:10px; text-align:right; font-size:18px;">$${totalDollars}</td>
    </tr>
    <tr>
      <td colspan="2" style="padding:10px; text-align:left;">*Includes shipping and other applicable fees</td>
    </tr>
  `;

  // Prepare tracking link
  const carrierTrackingUrls = {
    UPS: "https://www.ups.com/track?tracknum=",
    FedEx: "https://www.fedex.com/fedextrack/?trknbr=",
    USPS: "https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=",
    DHL: "https://www.dhl.com/global-en/home/tracking.html?tracking-id=",
  };
  const trackingLink =
    tracking_number && carrierTrackingUrls[tracking_carrier]
      ? `<a href="${carrierTrackingUrls[tracking_carrier]}${tracking_number}" target="_blank">${tracking_number}</a>`
      : tracking_number
        ? tracking_number
        : "Not currently available";

  // Extract shipment address details
  const { address_name, address, address_optional, city, state } =
    shipmentAddress || {};

  // Build the complete HTML email content with the new design
  const htmlContent = `
    <!DOCTYPE html>
    <html lang="en" xmlns="http://www.w3.org/1999/xhtml">
      <head>
        <meta charset="UTF-8" />
        <meta http-equiv="x-ua-compatible" content="ie=edge" />
        <title>Delivery Confirmation - Fullproof</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <style type="text/css">
          body {
            margin: 0;
            padding: 0;
            background-color: #fff;
            font-family: Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -webkit-text-size-adjust: none;
          }
          table {
            border-collapse: collapse;
            width: 100%;
          }
          a {
            text-decoration: none;
            color: inherit;
          }
          .container {
            max-width: 600px;
            margin: 0 auto;
            padding: 20px;
          }
          .header, .footer {
            text-align: center;
          }
          .header img {
            display: block;
            margin: 0 auto;
          }
          .title {
            font-size: 18px;
            font-weight: bold;
            margin: 20px 0;
            text-align: center;
          }
          .intro {
            font-size: 16px;
            line-height: 1.6;
            text-align: center;
            margin-bottom: 20px;
          }
          .button {
            display: inline-block;
            background-color: #007aff;
            color: #ffffff;
            font-size: 16px;
            font-weight: bold;
            padding: 12px 28px;
            border-radius: 100px;
            text-align: center;
            text-decoration: none;
            width: auto;
            margin: 20px 0;
          }
          .button-gray {
            display: inline-block;
            background-color: #8e8e93;
            color: #ffffff;
            font-size: 14px;
            font-weight: bold;
            padding: 10px 20px;
            border-radius: 20px;
            text-align: center;
            text-decoration: none;
          }
          .order-details {
            width: 100%;
            margin: 20px 0;
          }
          .order-details td {
            padding: 10px;
          }
          .footer {
            background-color: #000;
            color: #fff;
            padding: 20px;
            text-align: left;
          }
          .footer a {
            color: #fff;
            text-decoration: underline;
          }
        </style>
      </head>
      <body style="margin:0; padding:0; background-color:#ffffff;">
        <div class="container">
          <!-- Header -->
          <div class="header">
            <img src="https://firebasestorage.googleapis.com/v0/b/fullproof-app.firebasestorage.app/o/Logos%2Ffullproof_logo_black.png?alt=media" alt="Fullproof Logo" width="200" />
          </div>
          
          <!-- Title -->
          <div class="title">Your Fullproof order has shipped!</div>
          
          <!-- Shipment Confirmation Image -->
          <div style="padding:20px 0; border-bottom:1px solid #ddd; text-align:center;">
            <img src="https://firebasestorage.googleapis.com/v0/b/fullproof-app.firebasestorage.app/o/Logos%2Forder_shipped.png?alt=media" alt="Order Shipped" width="100%" style="max-width:500px;" />
          </div>
          
          <!-- Intro Section -->
          <div style="font-size:18px; font-weight:bold; margin:20px 0; text-align:left;">
            Your order is on its way.
          </div>
          <div style="text-align:left; margin-bottom:10px;">
            ${shipmentAddress ? `${address_name || ""} - ${city || ""}, ${state || ""}` : ""}
          </div>
          <div style="text-align:left; margin-bottom:20px;">
            Tracking info: ${trackingLink}
          </div>
          <div style="text-align:left; margin-bottom:20px;">
           <div style="text-align:center; margin-bottom:20px; display:flex; flex-direction:column; align-items:center;">

          <a href="https://getfullproof.com/orderhistory"
             target="_blank"
             class="button"
             style="
               display:inline-block;
               background-color:#007aff;
               color:#ffffff;
               font-size:16px;
               font-weight:bold;
               padding:12px 28px;
               border-radius:100px;
               text-align:center;
               text-decoration:none;
               width:100%; 
               margin:20px 0;
             "
           >
             View order
          </a>
        </div>
          </div>
          
          <!-- Order Details Table -->
          <table class="order-details" border="0" cellspacing="0" cellpadding="0">
            ${itemsHtml}
          </table>
          
          <!-- Footer -->
          <div class="footer">
            <p style="font-size:12px; line-height:1.6; margin-bottom:30px;">
              ©2025 Fullproof, Inc. or its affiliates. Fullproof and all related marks are trademarks of Fullproof, Inc. or its affiliates.
            </p>
            <br />
            <img src="https://firebasestorage.googleapis.com/v0/b/fullproof-app.firebasestorage.app/o/Logos%2Ffullproof_logo_white.png?alt=media" alt="Fullproof Footer Logo" style="height:24px; display:block;" />
          </div>
        </div>
      </body>
    </html>
  `;

  // Build plain text version
  const textContent = `
    Your order has shipped!
    
    Order #: ${sooperstock_order_id}
    
    Shipping Details:
    ${shipmentAddress ? `${address_name || "N/A"}, ${address || "N/A"}, ${city || "N/A"}, ${state || "N/A"}` : "N/A"}
    
    Tracking Info: ${tracking_number || "Not currently available"}
    
    Ordered Items:
    ${items
      .map((item) => {
        const itemPrice = (item.final_price * item.quantity).toFixed(2);
        return `${item.product_name} - Qty: ${item.quantity} - $${itemPrice}`;
      })
      .join("\n")}
    
    Total: $${totalDollars}
    
    Continue shopping at https://getfullproof.com
    
    ©2025 Fullproof, Inc. or its affiliates.
    By creating an account, you agree to our Terms of Service and Privacy Policy.
  `;

  // Create message object
  const message = {
    html: htmlContent,
    text: textContent,
    subject: `Your Fullproof order has shipped (${sooperstock_order_id})`,
    from: "no-reply@getfullproof.com",
  };

  try {
    await addDoc(collection(db, "Messages/Mail/DataBase"), {
      message,
      email: buyerEmail,
      to: [buyerEmail],
      mail_type,
    });
    alert("Delivery confirmation email prepared successfully");
    console.log("Delivery confirmation email prepared successfully");
  } catch (error) {
    alert(JSON.stringify(error));
    console.error(
      "Error adding delivery confirmation email to Firestore:",
      error,
    );
  }
};

export default createDeliveryMailConfirmation;
